import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './components/App'

export let startNewAchievements = (
  badgeTemplates,
  certTemplates,
  badges,
  certificates,
  acts,
  coursenum
) => {
  const root = createRoot(document.getElementById('newAchievementsApp'))
  root.render(
    <App
      badgeTemplates={badgeTemplates}
      certTemplates={certTemplates}
      badges={badges}
      certificates={certificates}
      acts={acts}
      coursenum={coursenum}
    />
  )
}
